import { render, staticRenderFns } from "./ClientProjectsEditResults.vue?vue&type=template&id=2e235ab1&"
import script from "./ClientProjectsEditResults.vue?vue&type=script&lang=js&"
export * from "./ClientProjectsEditResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports